enum SceneKeys{
    Preloader='preloader',
    GameScene='game',
    UIScene='UIScene',
    RockyRoller='rocky-roller',
    GolbalScene='global-scene',
    PokerScene='poker-scene'
}
export default SceneKeys